import dayjs from 'dayjs';

export const getNavigatorLocale = () => {
  //use  navigator["xxx"] because typescript shows has not this property
  const locale =
    navigator['userLanguage'] ||
    (navigator.languages &&
      navigator.languages.length &&
      navigator.languages[0]) ||
    navigator.language ||
    navigator['browserLanguage'] ||
    navigator['systemLanguage'];
  return locale.toLowerCase();
};

export const convertToDefaultDate = (date) => {
  return dayjs(date).format('YYYY-MM-DD');
};

export const getBase64Value = (param: string) => {
  if (!param) {
    return undefined;
  }

  try {
    const value = window.atob(param);
    return JSON.parse(value);
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
